
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sia-mentoring",
      function () {
        return require("private-next-pages/sia-mentoring/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sia-mentoring"])
      });
    }
  